module.exports = __webpack_public_path__ + "img/instagram.2a9219d6.svg";